import { NextRouter, useRouter as useNextRouter } from 'next/router';
import React from 'react';

export type UseRouterState = NextRouter & {
  asPathWithoutParams: string;
};

export default function useRouter(): UseRouterState {
  const router = useNextRouter();

  const asPathWithoutParams = React.useMemo(() => {
    return router.asPath.split('?')[0];
  }, [router.asPath]);

  return {
    ...router,
    asPathWithoutParams
  };
}
